import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import logo1 from "./assets/logo1.svg";
import logo2 from "./assets/logo2.svg";
const Footer = () => {
  return (
    <div className="footer-section">

      {/* TOP GRID */}
      <div className="footer-container">

        {/* LOGO */}
        <div className="footer-logo-block">
          <img src={logo1} alt="Logo" className="footer-logo" />
        </div>

        {/* SERVICES */}
        <div className="footer-col">
          <h4>Services</h4>
          <a>Architecture</a>
          <a>Structural Design</a>
          <a>Consulting</a>
          <a>Project Management</a>
        </div>

        {/* COMPANY */}
        <div className="footer-col">
          <h4>Company</h4>
          <a>About Us</a>
          <a>Projects</a>
          <a>Careers</a>
          <a>Contact</a>
        </div>

        {/* RESOURCES */}
        <div className="footer-col">
          <h4>Resources</h4>
          <a>FAQ</a>
          <a>Blog</a>
          <a>Case Studies</a>
          <a>Insights</a>
        </div>

      </div>

      {/* DIVIDER */}
      <div className="footer-divider"></div>

      {/* SOCIAL ICONS */}
      <div className="footer-social">
        <a href="https://www.instagram.com/leo_engineering_consultancy?igsh=MzRlODBiNWFlZA==">
          <FontAwesomeIcon icon={faInstagram} />
        </a>

        <a href="https://www.facebook.com/share/AV77PGDkxVe3Zp3R/?mibextid=LQQJ4d">
          <FontAwesomeIcon icon={faFacebookF} />
        </a>

        <a href="https://linkedin.com">
          <FontAwesomeIcon icon={faLinkedinIn} />
        </a>
      </div>

      {/* COPYRIGHT */}
      <div className="footer-copy">
        © {new Date().getFullYear()} Leo Engineering Consultancy. All rights reserved.
      </div>

    </div>
  );
};

export default Footer;